/*==========================
 購物車 相關功能Service

 Author : Alan
 最後更新時間 : 2016 / 02 / 26
==========================*/

window.InifECShared.factory("ShoppingCartService", ['$q', '$http', '$rootScope', function($q, $http, $rootScope) {

    var factory = {};

    // ------------------------------
    // 新增商品至購物車
    // ------------------------------
    var addProductToShoppingCart = function(productid, spec, addCount, processRemark, userRemark, supplier) {

    	var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "addToShoppingCart",
                productid: productid,
                spec: spec,
                addCount: addCount,
                processRemark: processRemark,
                userRemark: userRemark,
                supplier: supplier
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                
                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);

            } else {
                getShoppingCart(true);
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {

            defer.reject(data);
            console.error("[InifEC Error] : ShoppingCartService.addProductToShoppingCart request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 更改購物車商品規格
    // ------------------------------
    var changeShoppingCartItem = function(orderitemid, productid, spec, processRemark, supplier, cartType) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "changeShoppingCartItem",
                orderitemid: orderitemid,
                productid: productid,
                spec: spec,
                processRemark: processRemark,
                supplier: supplier,
                cartType: cartType,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                
                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);

            } else {
                getShoppingCart(true);
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {

            defer.reject(data);
            console.error("[InifEC Error] : ShoppingCartService.changeShoppingCartItem request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 從購物車移除商品
    // ------------------------------
    var removeProductFromShoppingCart = function(orderitemid, cartType) {

    	var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "reomveShoppingCartItem",
                orderitemid: orderitemid,
                cartType: cartType,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {

                var orderitems;

                switch(cartType) {
                    case factory.cartTypeMap.defaultCart:
                        orderitems = factory.defaultCart;
                        break;
                    case factory.cartTypeMap.designCart:
                        orderitems = factory.designCart;
                        break;
                    case factory.cartTypeMap.emergencyCart:
                        orderitems = factory.emergencyCart;
                        break;
                    default:
                        return;
                }

            	for(var i = 0 ; i < orderitems.length ; i++){
            		if(orderitems[i].orderitemid == orderitemid){
            			orderitems.remove(i);
            			break;
            		}
            	}

                getShoppingCart(true);
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : ShoppingCartService.removeProductFromShoppingCart request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 從已經完成的訂單中將商品加入購物車
    // ------------------------------
    var reOrderToShoppingCart = function(orderid) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "reOrderToShoppingCart",
                orderid: orderid
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                getShoppingCart(true);
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : ShoppingCartService.reOrderToShoppingCart request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 取得購物車內容
    //
    // 購物車將會分２種車來裝不同購物型態的商品 
    //
    // defaultCart 一般商品
    // designCart  設計商品（需先報價）
    // emergencyCart  急件商品
    //
    // ------------------------------
    var getShoppingCart = function (skipCache) {

    	if(factory.defer && !skipCache){
            return factory.defer.promise;
        }

    	factory.defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "getShoppingCart"
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }
                
                factory.defer.reject(data.error);
            } else {
    
                if(data) {
                    // 一般商品
                    if(Array.isArray(data.defaultCart) && data.defaultCart.length > 0) {
                        factory.defaultCart.length = 0;
                        Array.prototype.push.apply(factory.defaultCart, data.defaultCart);
                    } else if(skipCache) {
                        factory.defaultCart.length = 0;
                    }

                    // 設計商品（需先報價）
                    if(Array.isArray(data.designCart) && data.designCart.length > 0) {
                        factory.designCart.length = 0;
                        Array.prototype.push.apply(factory.designCart, data.designCart);
                    } else if(skipCache) {
                        factory.designCart.length = 0;
                    }

                    // 急件商品
                    if(Array.isArray(data.emergencyCart) && data.emergencyCart.length > 0) {
                        factory.emergencyCart.length = 0;
                        Array.prototype.push.apply(factory.emergencyCart, data.emergencyCart);
                    } else if(skipCache) {
                        factory.emergencyCart.length = 0;
                    }
                }

                factory.defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            factory.defer.reject(data);
            console.error("[InifEC Error] : ShoppingCartService.getShoppingCart request error.");
            console.error("status : " + status);
        });

        return factory.defer.promise;
    }

    // ------------------------------
    // 更新使用者備註
    // ------------------------------
    var updateUserRemark = function (orderitemid, userRemark, cartType) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "updateUserRemark",
                orderitemid: orderitemid,
                userRemark: userRemark,
                cartType: cartType,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : ShoppingCartService.updateUserRemark request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 取得購物車內容
    // ------------------------------
    var getShoppingCartItems = function(cartType) {
        
        switch(cartType) {
            case factory.cartTypeMap.defaultCart:
                return factory.defaultCart;
            case factory.cartTypeMap.designCart:
                return factory.designCart;
            case factory.cartTypeMap.emergencyCart:
                return factory.emergencyCart;
        }
    }

    // ------------------------------
    // 取得購物車內容數量
    // ------------------------------
    var getShoppingCartItemSize = function(cartType) {

        switch(cartType) {
            case factory.cartTypeMap.defaultCart:
                return factory.defaultCart.length;
            case factory.cartTypeMap.designCart:
                return factory.designCart.length;
            case factory.cartTypeMap.emergencyCart:
                return factory.emergencyCart.length;
        }
    }

    // ------------------------------
    // 取得購物車總價
    // ------------------------------
    var getTotalAmount = function(cartType) {

        var items;

        switch(cartType) {
            case factory.cartTypeMap.defaultCart:
                items = factory.defaultCart;
                break;
            case factory.cartTypeMap.designCart:
                items = factory.designCart;
                break;
            case factory.cartTypeMap.emergencyCart:
                items = factory.emergencyCart;
                break;
        }

    	if(!items || items.length == 0){
    		return 0;
    	}

    	var totalamount = 0;
        var item;

    	for(var i = 0 ; i < items.length ; i++){
            item = items[i];
            totalamount += getProductTotalPrice(item);
    	}

    	return totalamount;
    }

    // ------------------------------
    // 取得購物車某種送件方式的總價
    // ------------------------------
    var getTotalAmountWithProductDelivery = function(cartType, productDelivery) {

        var items;

        switch(cartType) {
            case factory.cartTypeMap.defaultCart:
                items = factory.defaultCart;
                break;
            case factory.cartTypeMap.designCart:
                items = factory.designCart;
                break;
            case factory.cartTypeMap.emergencyCart:
                items = factory.emergencyCart;
                break;
        }

        if(!items || items.length == 0){
            return 0;
        }

        var totalamount = 0;
        var item;

        for(var i = 0 ; i < items.length ; i++){
            item = items[i];
            if(item.spec && item.spec.productDelivery == productDelivery) {
                totalamount += getProductTotalPrice(item);
            }
        }

        return totalamount;
    }

    // --------------------------------
    // 取得加工費用
    //
    // return -1 為 沒該欄位，而不是0元
    // --------------------------------
    var getProcessPrice = function(orderitem, pro) {

        if(!orderitem.spec.processPriceCost) {
            return -1;
        }

        var priceCost = orderitem.spec.processPriceCost[pro.key];

        if(!priceCost || priceCost.price == undefined) {
            return -1;
        }

        return priceCost.price;
    }

    // --------------------------------
    // 取得加工費用總額
    // 
    // return -1 為 沒該欄位，而不是0元
    // --------------------------------
    var getTotalProcessPrice = function(orderitem) {

        var price = 0;
        var processPrice = 0;
        var hasPrice = false;

        if(orderitem.spec && orderitem.spec.process && orderitem.spec.process.length > 0) {

            for(var i = 0; i < orderitem.spec.process.length; i++) {
                processPrice = getProcessPrice(orderitem, orderitem.spec.process[i]);

                if(processPrice < 0) {
                    continue;
                }

                hasPrice = true;
                price += processPrice;
            }
        }

        if(!hasPrice) {
            return -1;
        } else {
            return price;
        }
    }

    // --------------------------------
    // 取得特殊加工費用
    //
    // return -1 為 沒該欄位，而不是0元
    // --------------------------------
    var getOfferProcessPrice = function(orderitem, pro) {

        if(!orderitem.spec.offerProcessPriceCost) {
            return -1;
        }

        var priceCost = orderitem.spec.offerProcessPriceCost[pro.key];

        if(!priceCost || priceCost.price == undefined) {
            return -1;
        }

        return priceCost.price;
    }

    // --------------------------------
    // 取得特殊加工費用總額
    // 
    // return -1 為 沒該欄位，而不是0元
    // --------------------------------
    var getTotalOfferProcessPrice = function(orderitem) {

        var price = 0;
        var offerProcessPrice = 0;
        var hasPrice = false;

        if(orderitem.spec && orderitem.spec.offerProcess && orderitem.spec.offerProcess.length > 0) {

            for(var i = 0; i < orderitem.spec.offerProcess.length; i++) {
                offerProcessPrice = getOfferProcessPrice(orderitem, orderitem.spec.offerProcess[i]);

                if(offerProcessPrice < 0) {
                    continue;
                }

                hasPrice = true;
                price += offerProcessPrice;
            }
        }

        if(orderitem.charge > 0) {
            hasPrice = true;
            price += orderitem.charge;
        }

        if(!hasPrice) {
            return -1;
        } else {
            return price;
        }
    }
    
    // --------------------------------
    // 取得商品總額
    // --------------------------------
    var getProductTotalPrice = function(orderitem) {

        var price = orderitem.price;
        var totalProcessPrice = getTotalProcessPrice(orderitem);
        var totalOfferProcessPrice = getTotalOfferProcessPrice(orderitem);

        if(totalProcessPrice > -1) {
            price += totalProcessPrice;
        }

        if(totalOfferProcessPrice > -1) {
            price += totalOfferProcessPrice;
        }

        return price;
    }

    // ------------------------------
    // 取得所有類型購物車內容數量
    // ------------------------------
    var getAllCartShoppingCartItemSize = function() {

        return factory.defaultCart.length + factory.designCart.length + factory.emergencyCart.length;
    }

    // ------------------------------
    // 取得所有類型購物車總價
    // ------------------------------
    var getAllCartTotalAmount = function() {

        var totalamount = 0;
        for(var i = 0 ; i < factory.defaultCart.length ; i++){
            totalamount += getProductTotalPrice(factory.defaultCart[i]);
        }

        for(var i = 0 ; i < factory.designCart.length ; i++){
            totalamount += getProductTotalPrice(factory.designCart[i].price);
        }

        for(var i = 0 ; i < factory.emergencyCart.length ; i++){
            totalamount += getProductTotalPrice(factory.emergencyCart[i].price);
        }

        return totalamount;
    }
    
    // ------------------------------
    // 登出後要重置購物車
    // ------------------------------
    var logutResetCart = function() {

        factory.defaultCart.length = 0;
        factory.designCart.length = 0;
        factory.emergencyCart.length = 0;
        factory.tmp_defaultCart.length = 0;
        factory.tmp_designCart.length = 0;
        factory.tmp_emergencyCart.length = 0;
        factory.defer = undefined;
    }

    // ------------------------------
    // 檢查購物車是否有特殊加工
    // ------------------------------
    var checkAllCartHasOfferProcess = function() {

        for(var i = 0 ; i < factory.defaultCart.length ; i++){
            if(factory.defaultCart[i].spec && factory.defaultCart[i].spec.offerProcess && factory.defaultCart[i].spec.offerProcess.length > 0) {
                return true;
            }
        }

        for(var i = 0 ; i < factory.designCart.length ; i++){
            if(factory.designCart[i].spec && factory.designCart[i].spec.offerProcess && factory.designCart[i].spec.offerProcess.length > 0) {
                return true;
            }
        }

        for(var i = 0 ; i < factory.emergencyCart.length ; i++){
            if(factory.emergencyCart[i].spec && factory.emergencyCart[i].spec.offerProcess && factory.emergencyCart[i].spec.offerProcess.length > 0) {
                return true;
            }
        }

        return false;
    }

    // ------------------------------
    // init
    // ------------------------------
    var init = function() {

    	getShoppingCart();
    }

    /*==========================
        Members
    ==========================*/
    
    factory.cartTypeMap = {
        defaultCart: 0,
        designCart: 1,
        emergencyCart: 2,
    };

    /**
     * 購物車內容
     */
    // 一般商品
    factory.defaultCart = [];
    // 設計商品（需先報價）
    factory.designCart = [];
    // 急件商品
    factory.emergencyCart = [];

    /**
     * 購物車暫存內容 用來記錄選好的檔案的商品
     */
    factory.tmp_defaultCart = [];
    factory.tmp_designCart = [];
    factory.tmp_emergencyCart = [];
    
    /*==========================
        Methods
    ==========================*/
    // 新增商品至購物車
    factory.addProductToShoppingCart = addProductToShoppingCart;
    // 更改購物車商品規格
    factory.changeShoppingCartItem = changeShoppingCartItem;
    // 從購物車移除商品
    factory.removeProductFromShoppingCart = removeProductFromShoppingCart;
    // 從已經完成的訂單中將商品加入購物車
    factory.reOrderToShoppingCart = reOrderToShoppingCart;
    // 取得購物車內容
    factory.getShoppingCart = getShoppingCart;
    // 取得購物車內容
    factory.getShoppingCartItems = getShoppingCartItems;
    // 取得購物車內容數量
    factory.getShoppingCartItemSize = getShoppingCartItemSize;
    // 取得購物車總價格
    factory.getTotalAmount = getTotalAmount;
    // 取得購物車某種送件方式的總價
    factory.getTotalAmountWithProductDelivery = getTotalAmountWithProductDelivery;
    // 取得加工費用
    factory.getProcessPrice = getProcessPrice;
    // 取得加工費用總額
    factory.getTotalProcessPrice = getTotalProcessPrice;
    // 取得商品總額
    factory.getProductTotalPrice = getProductTotalPrice;
    // 取得特殊加工費用
    factory.getOfferProcessPrice = getOfferProcessPrice;
    // 取得特殊加工費用總額
    factory.getTotalOfferProcessPrice = getTotalOfferProcessPrice;
    // 取得所有類型購物車內容數量
    factory.getAllCartShoppingCartItemSize = getAllCartShoppingCartItemSize;
    // 取得所有類型購物車總價
    factory.getAllCartTotalAmount = getAllCartTotalAmount;
    // 登出後要重置購物車
    factory.logutResetCart = logutResetCart;
    // 更新使用者備註
    factory.updateUserRemark = updateUserRemark;
    // 檢查購物車是否有特殊加工
    factory.checkAllCartHasOfferProcess = checkAllCartHasOfferProcess;

    init();
    
    return factory;
}]);